import * as snackbarActions from './actions'

import { store } from "../../reducers";

export const close = ( event ) => {
	store.dispatch( snackbarActions.close() );

	event.preventDefault();
};

export const showMessage = ( message ) => {
	store.dispatch( snackbarActions.showMessage( message ) );

	setTimeout( () => {
		store.dispatch( snackbarActions.close() );
	}, 4000 );
};


// WEBPACK FOOTER //
// ./src/api/snackbar/index.js